import { Stack, type SxProps } from '@mui/material';

import formatBytes from 'shared/utils/formatBytes';

import { Styled } from './FilesList.styled';

type ClientFilesListProps = {
  files: File[];
  sx?: SxProps;
  onChange: (files: File[]) => void;
};

const ClientFilesList = ({ files, sx, onChange }: ClientFilesListProps) => {
  const handleRemoveFile = (removedFile: File) => {
    const newFiles = files.filter((file) => file.name !== removedFile.name);

    onChange(newFiles);
  };

  return (
    <Styled.List sx={sx}>
      {files.map((file) => (
        <Styled.ListItem key={file.name}>
          <Styled.TextOverflow>
            <Styled.FileName>{file.name}</Styled.FileName>
          </Styled.TextOverflow>

          <Stack alignItems="center" direction="row" spacing={1}>
            <Styled.FileMetadata>{formatBytes(file.size)}</Styled.FileMetadata>
            <Styled.IconButton onClick={() => handleRemoveFile(file)}>
              <Styled.ClearIcon color="primary" />
            </Styled.IconButton>
          </Stack>
        </Styled.ListItem>
      ))}
    </Styled.List>
  );
};

export default ClientFilesList;
